import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { TechnicalManual } from '../business-entities/technical-manual-model';
import { TechnicalManualDataService } from '../data-services/technical-manual-data.service';

@Injectable({
    providedIn: 'root'
})

export class TechnicalManualBusinessService {
    constructor(private service: TechnicalManualDataService) {
    }
    technicalManualId:number
    technicalManualList: TechnicalManual[];
    technicalManual: TechnicalManual;
    async getTechnicalManualList(): Promise<TechnicalManual[]> {
        await this.service
            .getTechnicalManualList()
            .then(
                (res: GenericResponse<Array<TechnicalManual>>) => {
                    this.technicalManualList = res.responseObject;
                }
            );
        return this.technicalManualList;
    }
    deleteTechnicalManual(id: number): Promise<any> {
        return this.service.deleteTechnicalMaual(id);
    }

    async getTechnicalManualById(technicalmanualId: number) {
        await this.service
            .getTechnicalManualById(technicalmanualId)
            .then(
                (res: GenericResponse<TechnicalManual>) => {
                    this.technicalManual = res.responseObject;
                }
            );
        return this.technicalManual;
    }

    addTechnicalManual(model:any):Promise<any>{
        return this.service.addTechnicalManual(model);
    }

    editTechnicalManual(model:any):Promise<any>{
        return this.service.editTechnicalManual(model);
    }
}